.container {
  display: flex;
  gap: var(--via-space-200);
  flex-wrap: wrap;

  /* height of 1 row of chips, to avoid layout shift (equal to height of XSmall button) */
  min-height: 22px;

  overflow: hidden;
}
